<template>
  <div class="header">
    <div class="logo">
      <div class="item-img" @click="linkOver(0)">
        <img src="../../../static/img/header/logoB.png" width="430px" height="62px" alt="联盟logo">
      </div>
      <div class="item-sub">
        <div @click="linkOver(1)">联盟概况</div>
        <img src="../../../static/img/headactive.png" alt="" class="header-activity">
      </div>
      <div class="item-sub">
        <div @click="linkOver(2)">行业动态</div>
        <img src="../../../static/img/headactive.png" alt="" class="header-activity">
      </div>
      <div class="item-sub">
        <el-dropdown style="width:100px;font-size:18px;" @command="linkOver">
          <span class="el-dropdown-link">
            知识共享<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <img src="../../../static/img/headactive.png" alt="" class="header-drop">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="31">博士讲堂</el-dropdown-item>
            <el-dropdown-item command="32">专家解析</el-dropdown-item>
            <el-dropdown-item command="33">权威报告</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="item-sub">
        <div @click="linkOver(4)">推荐产品</div>
        <img src="../../../static/img/headactive.png" alt="" class="header-activity">
      </div>
      <div class="item-sub">
        <div @click="linkOver(5)">联盟活动</div>
        <img src="../../../static/img/headactive.png" alt="" class="header-activity">
      </div>
      <div class="item-sub" @click="linkOver(6)">
        <div>联盟会员</div>
        <img src="../../../static/img/headactive.png" alt="" class="header-activity">
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
import * as gettersType from '@/store/getters/type';
import { localStorage } from '@/common/util/storage';
export default {
  name: 'modHeader',
  data() {
    return {
      adminSign: false,
      localStorage,
      gettersType,
      trendPlay: false,
      knowledgePlay: false,
      isFind: false,
      isLogin: false,
      keyFindWord: '',
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {
    ...mapMutations({
      setUserInfo: mutationsType.SET_USER_INFO
    }),
    handleSelect(key, keyPath) {},
    findShow() {
      this.isFind = !this.isFind;
    },
    linkOver(num) {
      let linkAction = this;
      switch (parseInt(num)) {
        case 0:
          linkAction.$router.push({ name: 'home' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          break;
        case 1:
          linkAction.$router.push({ name: 'overview' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          $('.header-activity')
            .eq(num - 1)
            .css('display', 'block');
          break;
        case 2:
          linkAction.$router.push({ name: 'news' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          $('.header-activity')
            .eq(num - 1)
            .css('display', 'block');
          break;
        case 31:
          linkAction.$router.push({ name: 'doctorSpace' });
          window.localStorage.setItem('knowledgeRoom', '1');
          $('.header-drop').css('display', 'block');
          $('.header-activity').css('display', 'none');
          break;
        case 32:
          linkAction.$router.push({ name: 'opinion' });
          window.localStorage.setItem('knowledgeRoom', '2');
          $('.header-drop').css('display', 'block');
          $('.header-activity').css('display', 'none');
          break;
        case 33:
          linkAction.$router.push({ name: 'poilticalExplain' });
          window.localStorage.setItem('knowledgeRoom', '3');
          $('.header-drop').css('display', 'block');
          $('.header-activity').css('display', 'none');
          break;
        case 4:
          linkAction.$router.push({ name: 'product' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          $('.header-activity')
            .eq(num - 2)
            .css('display', 'block');
          break;
        case 5:
          linkAction.$router.push({ name: 'activity' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          $('.header-activity')
            .eq(num - 2)
            .css('display', 'block');
          break;
        case 6:
          linkAction.$router.push({ name: 'members' });
          $('.header-activity').css('display', 'none');
          $('.header-drop').css('display', 'none');
          $('.header-activity')
            .eq(num - 2)
            .css('display', 'block');
          break;
      }
    }
  }
};
</script>
<style scoped>
.header {
  background-color: #fff;
  height: 60px;
  padding: 10px 0;
}
.logo {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.logo .item-img {
  float: left;
  margin: 0 60px 0 8%;
  cursor: pointer;
}
.logo .item-sub {
  float: left;
  margin-top: 16px;
  height: 100%;
  cursor: pointer;
  width: 120px;
  text-align: center;
  font-size: 20px !important;
  position: relative;
  top: 0;
  font-size: 18px;
}
.item-sub .header-sub-sub {
  background-color: #172b9f;
  width: 100px;
  text-align: center;
  font-size: 18px;
  margin-top: 5px;
  padding: 0 10px 10px;
  border: 1px solid #172b9f;
  margin-left: -10px;
  /* display: none; */
  position: relative;
}
.item-sub .header-sub-sub div {
  margin-top: 10px;
}
.newsDrop {
  position: relative;
  top: 0;
  left: 0;
}

.findInput {
  position: relative;
  top: 0;
  left: 0;
  width: 50px;
  float: left;
  margin-top: 16px;
  margin-left: 245px;
  height: 100%;
  cursor: pointer;
  text-align: center;
  font-size: 20px !important;
}
.find-sub {
  position: relative;
  top: -40px;
  left: -200px;
}
.item-login {
  float: left;
  margin-top: 16px;
  margin-left: 10px;
  cursor: pointer;
  width: 100px;
  font-size: 16px !important;
  overflow: hidden;
}
.item-login div {
  float: left;
}
.login-module {
  position: absolute;
  top: 75px;
  right: 1px;
  z-index: 90;
  width: 400px;
}
.header-activity {
  margin-left: 23px;
  margin-top: 10px;
  display: none;
}
.header-drop {
  margin-top: 12px;
  margin-left: 5px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/common/area/reHeader.vue